import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login.js';
import home from './modules/home.js';
Vue.use(Vuex)
 
export default new Vuex.Store({
    modules: {
        login,
        home
    }
})